import Vue from 'vue'
import Router from 'vue-router'
import server from './server'

Vue.use(Router)

const entities = {
  Member: {
    url: 'members'
  },
  Organization: {
    url: 'organizations'
  }
}

const afterAuth = (_to, from, next) => {
  if (_to.query.t_) {
    server.logout()
    next()
  } else {
    if (server.token) {
      next(from.path)
    } else {
      next()
    }
  }
}

const beforeEnter = async function (to, _from, next) {
  document.title = to.meta.title
  if (!server.metadata) {
    await server.loadMetadata(entities)
  }
  if (!server.organizationMetadata) {
    await server.loadOrganizationMetadata(entities)
  }
  next()
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ './views/Dashboard'),
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ './views/Login'),
    beforeEnter: afterAuth,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import(/* webpackChunkName: "Permissions" */ './views/Permissions'),
    meta: {
      title: 'Permissions'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "Authentication" */ './views/Register'),
    beforeEnter: afterAuth,
    meta: {
      title: 'Register'
    }
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "ForgotPassword" */ './views/ForgotPassword'),
    meta: {
      title: 'Forgot Password'
    }
  },
  {
    path: '/reset_password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "ResetPassword" */ './views/ResetPassword'),
    meta: {
      title: 'Reset Password'
    }
  },
  {
    path: '/create_account',
    name: 'CreateAccount',
    component: () => import(/* webpackChunkName: "CreateOrganization" */ './views/CreateOrganization'),
    meta: {
      title: 'Create Account'
    }
  },
  {
    path: '/create_basic_account',
    name: 'CreateBasicAccount',
    component: () => import(/* webpackChunkName: "CreateBasicAccount" */ './views/CreateBasicAccount'),
    meta: {
      title: 'Create Basic Account'
    }
  },
  {
    path: '/register_email',
    name: 'RegisterEmail',
    component: () => import(/* webpackChunkName: "RegisterEmail" */ './views/RegisterEmail'),
    meta: {
      title: 'Register Email'
    }
  }
  ]
})

router.beforeEach(beforeEnter)

export default router
